import axios from "../http_v2";

export default {
  list(params) {
    return axios.get("cmsservice/cms_case/page", params);
  },
  listall(params) {
    return axios.get("cmsservice/cms_case/page/share", params);
  },
  info(id) {
    return axios.get("cmsservice/cms_case/info/" + id, {});
  },
  add(params) {
    return axios.post("cmsservice/cms_case/add", params);
  },
  update(params) {
    return axios.post("cmsservice/cms_case/update", params);
  },
  //上架下架
  status(params) {
    return axios.get("cmsservice/cms_case/status", params);
  },
  //置顶
  top(params) {
    return axios.get("cmsservice/cms_case/top", params);
  },
  delete(params) {
    return axios.post("cmsservice/cms_case/delete", params);
  },
  type: {
    tree(params) {
      return axios.get("cmsservice/caseSort/tree", params);
    },
    add(params) {
      return axios.post("cmsservice/caseSort/add", params);
    },
    update(params) {
      return axios.put("cmsservice/caseSort/update", params);
    },
    delete(id) {
      return axios.delete("cmsservice/caseSort/del/" + id, {});
    }
  },
  topic(params) {
    return axios.get("cmsservice/cms_case/page/for/topic", params);
  },
};
